import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import '../styles/LoginModal.css';

const CarAnimation = () => (
  <div className="lm-scene-wrap">
    <svg viewBox="0 0 400 250" width="100%" style={{ overflow: 'visible' }}>

      <defs>
        {/* Sky gradient */}
        <radialGradient id="lm-skyGrad" cx="50%" cy="0%" r="90%">
          <stop offset="0%"   stopColor="#001535" />
          <stop offset="100%" stopColor="#000810" />
        </radialGradient>

        {/* Headlight glow filter */}
        <filter id="lm-headGlow" x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        {/* Taillight glow filter */}
        <filter id="lm-tailGlowF" x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="2.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        {/* Ground shadow blur */}
        <filter id="lm-shadowBlur">
          <feGaussianBlur stdDeviation="3.5" />
        </filter>

        {/* Headlight beam cone — pointing LEFT */}
        <radialGradient id="lm-headBeam" cx="100%" cy="50%" r="100%" fx="100%" fy="50%">
          <stop offset="0%"   stopColor="#FFD60A" stopOpacity="0.48" />
          <stop offset="40%"  stopColor="#FFE84D" stopOpacity="0.14" />
          <stop offset="100%" stopColor="#FFD60A" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* ── Sky ── */}
      <rect x="0" y="0" width="400" height="200" fill="url(#lm-skyGrad)" />

      {/* ── Stars ── */}
      <text x="30"  y="40"  fontFamily="sans-serif" fontSize="10" fill="#FFD60A" className="lm-star lm-s1">✦</text>
      <text x="340" y="30"  fontFamily="sans-serif" fontSize="8"  fill="#FFD60A" className="lm-star lm-s2">✦</text>
      <text x="180" y="25"  fontFamily="sans-serif" fontSize="7"  fill="#FFD60A" className="lm-star lm-s3">✦</text>
      <text x="370" y="70"  fontFamily="sans-serif" fontSize="11" fill="#FFD60A" className="lm-star lm-s4">✦</text>
      <text x="60"  y="80"  fontFamily="sans-serif" fontSize="6"  fill="#ffffff" className="lm-star lm-s2">✦</text>
      <text x="290" y="55"  fontFamily="sans-serif" fontSize="9"  fill="#FFD60A" className="lm-star lm-s3">✦</text>
      <text x="120" y="60"  fontFamily="sans-serif" fontSize="7"  fill="#ffffff" className="lm-star lm-s1">✦</text>

      {/* 🌙 Clean Half Moon */}
    <g>
      <circle cx="350" cy="50" r="16" fill="#F5F3CE" />
      <circle cx="358" cy="50" r="16" fill="url(#lm-skyGrad)" />
    </g>
  
      {/* ── Road ── */}
      <rect x="0" y="200" width="400" height="50" fill="#111827" />
      <rect x="0" y="216" width="400" height="4"  fill="#1e2a40" />
      {/* Road edge highlight */}
      <rect x="0" y="200" width="400" height="2"  fill="rgba(255,255,255,0.05)" />

      {/* Lane dashes — animated scroll left */}
      <rect x="10"  y="221" width="38" height="3" rx="1.5" fill="#FFD60A" opacity="0.45" className="lm-dash" />
      <rect x="90"  y="221" width="38" height="3" rx="1.5" fill="#FFD60A" opacity="0.45" className="lm-dash" />
      <rect x="170" y="221" width="38" height="3" rx="1.5" fill="#FFD60A" opacity="0.45" className="lm-dash" />
      <rect x="250" y="221" width="38" height="3" rx="1.5" fill="#FFD60A" opacity="0.45" className="lm-dash" />
      <rect x="330" y="221" width="38" height="3" rx="1.5" fill="#FFD60A" opacity="0.45" className="lm-dash" />

      {/* 💬 Welcome Bubble */}
      <g className="lm-bubble">
        <rect x="120" y="40" width="160" height="50" rx="14" fill="#ffffff" stroke="#FFD60A" strokeWidth="2"/>
        
        {/* Pointer */}
        <polygon points="180,90 170,105 200,90" fill="#ffffff" stroke="#FFD60A" strokeWidth="2"/>

        {/* Text */}
        <text x="200" y="62" textAnchor="middle" fontSize="12" fontWeight="700" fill="#003566">
          Welcome!
        </text>
        <text x="200" y="78" textAnchor="middle" fontSize="10" fill="#666">
          Your car awaits you
        </text>
      </g>

      {/* ── CAR GROUP ── */}
      <g id="lm-car-grp">

        {/* Ground shadow */}
        <ellipse cx="190" cy="207" rx="100" ry="7"
          fill="rgba(0,0,0,0.35)" filter="url(#lm-shadowBlur)" />

        {/* ── Headlight beam cone — LEFT side, pointing left ── */}
        <polygon
          points="72,158  0,138  0,180  72,172"
          fill="url(#lm-headBeam)"
          className="lm-beam-cone"
        />

        {/* ── Body ── */}
        <rect x="72" y="158" width="236" height="48" rx="9" fill="#002d6e" />

        {/* ── Roof ── */}
        <path d="M122 158 Q136 120 168 115 L236 115 Q268 120 282 158Z" fill="#002d6e" />
        {/* Roof inner highlight panel */}
        <path d="M132 156 Q144 125 170 120 L234 120 Q260 125 272 156Z" fill="#003d8f" opacity="0.55" />

        {/* ── Windows ── */}
        {/* Front/driver window (left side) */}
        <path d="M142 156 Q148 130 170 125 L202 125 L202 156Z"         fill="#8ecfed" opacity="0.82" />
        {/* Rear window */}
        <path d="M208 125 L234 125 Q254 130 262 156 L208 156Z"         fill="#8ecfed" opacity="0.82" />
        {/* Window outlines */}
        <path d="M142 156 Q148 130 170 125 L202 125 L202 156Z"         fill="none" stroke="#001f52" strokeWidth="1.8" />
        <path d="M208 125 L234 125 Q254 130 262 156 L208 156Z"         fill="none" stroke="#001f52" strokeWidth="1.8" />
        {/* B-pillar */}
        <line x1="205" y1="125" x2="205" y2="156" stroke="#001f52" strokeWidth="2.2" />
        {/* Window glints */}
        <path d="M152 152 Q158 136 172 128 L190 126"
          stroke="rgba(255,255,255,0.20)" strokeWidth="1.4" fill="none" strokeLinecap="round" />
        <path d="M216 127 L238 127 Q252 132 258 147"
          stroke="rgba(255,255,255,0.14)" strokeWidth="1.2" fill="none" strokeLinecap="round" />

        {/* ── Hood — front is LEFT side ── */}
        <path d="M282 158 L312 158 L312 178 L72 178 L72 158Z" fill="#002050" />

        {/* ── Front bumper — LEFT side ── */}
        <rect x="72"  y="188" width="32" height="18" rx="5" fill="#001840" />
        {/* Front chin splitter */}
        <rect x="73"  y="183" width="30" height="5"  rx="2" fill="#001030" />
        {/* Front grille */}
        <rect x="76"  y="165" width="12" height="9"  rx="2" fill="#001030" />
        <line x1="77"  y1="168" x2="87"  y2="168" stroke="#1a2a50" strokeWidth="1" />
        <line x1="77"  y1="171" x2="87"  y2="171" stroke="#1a2a50" strokeWidth="1" />

        {/* ── HEADLIGHTS — LEFT side (front of car) ── */}
        <rect x="72"  y="160" width="22" height="11" rx="4"
          fill="#FFD60A" id="lm-headlight" filter="url(#lm-headGlow)" />
        {/* DRL strip */}
        <rect x="73"  y="161" width="18" height="4.5" rx="2"
          fill="#ffffff" opacity="0.92" />
        {/* Lens */}
        <ellipse cx="81" cy="167" rx="5" ry="2.8"
          fill="rgba(255,220,60,0.65)" />
        {/* Lens reflection */}
        <rect x="74"  y="162" width="7" height="1.8" rx="1"
          fill="rgba(255,255,255,0.50)" />

        {/* ── TAILLIGHTS — RIGHT side (rear of car) ── */}
        <rect x="294" y="160" width="14" height="11" rx="3"
          fill="#CC0000" id="lm-tail" filter="url(#lm-tailGlowF)" />
        {/* Inner lens */}
        <rect x="295" y="161" width="11" height="4.5" rx="2"
          fill="#FF4444" opacity="0.82" />
        {/* DRL strip */}
        <rect x="295" y="168" width="11" height="2"   rx="1"
          fill="#FF2222" opacity="0.7" />
        {/* Rear bumper */}
        <rect x="296" y="188" width="14" height="18" rx="5" fill="#001840" />
        {/* Rear chin */}
        <rect x="297" y="183" width="12" height="5"  rx="2" fill="#001030" />

        {/* ── Side mirror LEFT (front) ── */}
        <rect x="87"  y="147" width="10" height="6" rx="2" fill="#002050" />
        <rect x="88"  y="148" width="8"  height="4" rx="1.5" fill="#8ecfed" opacity="0.4" />

        {/* ── Side mirror RIGHT (rear) ── */}
        <rect x="297" y="147" width="10" height="6" rx="2" fill="#002050" />
        <rect x="298" y="148" width="8"  height="4" rx="1.5" fill="#8ecfed" opacity="0.4" />

        {/* ── Door panel ── */}
        <rect x="172" y="168" width="52" height="14" rx="4" fill="#001840" opacity="0.45" />
        {/* Door handle */}
        <rect x="210" y="172" width="10" height="4" rx="2" fill="#FFD60A" opacity="0.7" />

        {/* ── Keyhole (door lock) ── */}
        <rect x="217" y="172" width="7" height="5" rx="1.5" fill="#FFD60A" id="lm-keyhole" />

        {/* ── Body shine lines ── */}
        <path d="M94 163 Q140 153 192 155"
          stroke="rgba(255,255,255,0.18)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
        <path d="M100 158 Q155 148 218 150"
          stroke="rgba(100,160,255,0.10)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        {/* Roof shine */}
        <path d="M142 133 Q180 124 240 126"
          stroke="rgba(255,255,255,0.12)" strokeWidth="1.8" fill="none" strokeLinecap="round" />

        {/* ── Brand badge ── */}
        <text x="172" y="192"
          fontFamily="'Georgia', serif" fontSize="8.5"
          fill="#FFD60A" fontWeight="bold" opacity="0.8" letterSpacing="0.5">
          Caryugo
        </text>

        {/* ── FRONT wheel — left side ── */}
        <circle cx="128" cy="202" r="20" fill="#111827" />
        <circle cx="128" cy="202" r="14" fill="#222540" />
        <circle cx="128" cy="202" r="8"  fill="#2e3550" />
        <circle cx="128" cy="202" r="3.5" fill="#505870" />
        <line x1="128" y1="194" x2="128" y2="210" stroke="#7080a0" strokeWidth="2"   strokeLinecap="round" className="lm-spoke" />
        <line x1="120" y1="202" x2="136" y2="202" stroke="#7080a0" strokeWidth="2"   strokeLinecap="round" className="lm-spoke" />
        <line x1="122" y1="196" x2="134" y2="208" stroke="#606888" strokeWidth="1.5" strokeLinecap="round" className="lm-spoke" />
        <line x1="134" y1="196" x2="122" y2="208" stroke="#606888" strokeWidth="1.5" strokeLinecap="round" className="lm-spoke" />
        <circle cx="128" cy="202" r="3.5" fill="#FFD60A" opacity="0.55" />
        <path d="M114,191 Q120,188 130,189"
          stroke="rgba(255,255,255,0.11)" strokeWidth="1.4" fill="none" strokeLinecap="round" />

        {/* ── REAR wheel — right side ── */}
        <circle cx="270" cy="202" r="20" fill="#111827" />
        <circle cx="270" cy="202" r="14" fill="#222540" />
        <circle cx="270" cy="202" r="8"  fill="#2e3550" />
        <circle cx="270" cy="202" r="3.5" fill="#505870" />
        <line x1="270" y1="194" x2="270" y2="210" stroke="#7080a0" strokeWidth="2"   strokeLinecap="round" className="lm-spoke" />
        <line x1="262" y1="202" x2="278" y2="202" stroke="#7080a0" strokeWidth="2"   strokeLinecap="round" className="lm-spoke" />
        <line x1="264" y1="196" x2="276" y2="208" stroke="#606888" strokeWidth="1.5" strokeLinecap="round" className="lm-spoke" />
        <line x1="276" y1="196" x2="264" y2="208" stroke="#606888" strokeWidth="1.5" strokeLinecap="round" className="lm-spoke" />
        <circle cx="270" cy="202" r="3.5" fill="#FFD60A" opacity="0.55" />
        <path d="M256,191 Q262,188 272,189"
          stroke="rgba(255,255,255,0.11)" strokeWidth="1.4" fill="none" strokeLinecap="round" />

      </g>{/* end #lm-car-grp */}

      {/* Keyhole pulse rings */}
      <circle cx="220" cy="175" r="0" fill="none" stroke="#FFD60A" strokeWidth="2"   id="lm-pr1" className="lm-pulse-r" />
      <circle cx="220" cy="175" r="0" fill="none" stroke="#FFD60A" strokeWidth="1.5" id="lm-pr2" className="lm-pulse-r" />

    </svg>
  </div>
);

/* ─────────────────────────────────────────────────────────────
   MAIN MODAL
───────────────────────────────────────────────────────────── */
const LoginModal = ({ onClose }) => {
  const [step, setStep]             = useState('phone');
  const [phone, setPhone]           = useState('');
  const [otp, setOtp]               = useState(['', '', '', '', '', '']);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState('');
  const [countdown, setCountdown]   = useState(0);
  const [userExists, setUserExists] = useState(false);
  const { updateUser }              = useAuth();
  const otpRefs                     = useRef([]);

  const startCountdown = () => {
    setCountdown(30);
    const interval = setInterval(() => {
      setCountdown(p => { if (p <= 1) { clearInterval(interval); return 0; } return p - 1; });
    }, 1000);
  };

  const handleSendOtp = async () => {
    if (phone.trim().length !== 10) { setError('Please enter a valid 10-digit mobile number'); return; }
    setLoading(true); setError('');
    try {
      const res = await authAPI.sendOtp(phone);
      setUserExists(res.data.user_exists);
      setStep('otp');
      startCountdown();
      setTimeout(() => otpRefs.current[0]?.focus(), 100);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send OTP. Please try again.');
    } finally { setLoading(false); }
  };

  const handleOtpChange = (i, val) => {
    const d = val.replace(/\D/g, '').slice(-1);
    const n = [...otp]; n[i] = d; setOtp(n); setError('');
    if (d && i < 5) otpRefs.current[i + 1]?.focus();
  };

  const handleOtpKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !otp[i] && i > 0) otpRefs.current[i - 1]?.focus();
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const p = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (p.length === 6) { setOtp(p.split('')); otpRefs.current[5]?.focus(); }
  };

  const handleVerifyOtp = async () => {
    const s = otp.join('');
    if (s.length !== 6) { setError('Please enter the complete 6-digit OTP'); return; }
    setLoading(true); setError('');
    try {
      const res = await authAPI.verifyOtp(phone, s);
      const { user, token } = res.data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(user));
      updateUser(user); onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid OTP. Please try again.');
      setOtp(['', '', '', '', '', '']); otpRefs.current[0]?.focus();
    } finally { setLoading(false); }
  };

  const handleResendOtp = async () => {
    setLoading(true); setError('');
    try {
      await authAPI.resendOtp(phone); startCountdown();
      setOtp(['', '', '', '', '', '']); otpRefs.current[0]?.focus();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to resend OTP.');
    } finally { setLoading(false); }
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value.replace(/\D/g, '').slice(0, 10)); setError('');
  };

  const otpComplete = otp.join('').length === 6;

  return (
    <div className="lm-overlay" onClick={onClose}>
      <div className="lm-container" onClick={e => e.stopPropagation()}>

        <button className="lm-close" onClick={onClose} aria-label="Close">✕</button>

        {/* ── LEFT: animation panel ── */}
        <div className="lm-left-panel">
          <div className="lm-brand">
            <span style={{ fontSize: '1.4rem' }}>🚗</span>
            <div className="lm-brand-name">Caryugo<b></b></div>
          </div>

          <CarAnimation />

          <p className="lm-tagline">India's most trusted<br />pre-owned car platform</p>
          <div className="lm-badges">
            <span className="lm-badge">✓ 10+ Cars</span>
            <span className="lm-badge">✓ Certified</span>
            <span className="lm-badge">✓ Trusted</span>
          </div>
        </div>

        {/* ── RIGHT: form panel ── */}
        <div className="lm-right-panel">
          {step === 'phone' ? (
            <>
              <div className="lm-icon-box">
                <svg width="28" height="28" viewBox="0 0 38 38" fill="none">
                  <rect x="7" y="17" width="24" height="17" rx="4" stroke="#003566" strokeWidth="2.5" />
                  <path d="M12 17V13a7 7 0 0114 0v4" stroke="#003566" strokeWidth="2.5" strokeLinecap="round" />
                  <circle cx="19" cy="25.5" r="3" fill="#FFD60A" />
                </svg>
              </div>
              <h2 className="lm-title">Login / Sign Up</h2>
              <p className="lm-sub">Enter your mobile number to continue your car journey</p>

              <div className="lm-field">
                <div className={`lm-phone-row${error ? ' err' : ''}`}>
                  <span className="lm-cc">🇮🇳 +91</span>
                  <input
                    type="tel" className="lm-phone-input" placeholder="Mobile Number"
                    value={phone} onChange={handlePhoneChange}
                    onKeyDown={e => e.key === 'Enter' && phone.length === 10 && handleSendOtp()}
                    maxLength="10" disabled={loading} autoFocus
                  />
                </div>
                {error && <p className="lm-err">{error}</p>}
              </div>

              <p className="lm-terms">
                By logging in, I agree to the{' '}
                <Link to="/terms" onClick={onClose}>terms &amp; conditions</Link>{' '}and{' '}
                <Link to="/privacy" onClick={onClose}>privacy policy</Link>
              </p>

              <button className="lm-cta" onClick={handleSendOtp} disabled={loading || phone.length !== 10}>
                {loading
                  ? <span className="lm-spinner" />
                  : <><span>Send OTP</span><span className="lm-arrow">→</span></>}
              </button>
              <p className="lm-trust">Starting our journey to build a trusted car marketplace</p>
            </>
          ) : (
            <>
              <div className="lm-icon-box">
                <svg width="28" height="28" viewBox="0 0 38 38" fill="none">
                  <circle cx="16" cy="16" r="10" stroke="#003566" strokeWidth="2.5" />
                  <circle cx="16" cy="16" r="4.5" fill="#003566" />
                  <path d="M23 23L35 35" stroke="#003566" strokeWidth="2.5" strokeLinecap="round" />
                  <path d="M29 32L32 29" stroke="#FFD60A" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
              </div>
              <h2 className="lm-title">{userExists ? 'Welcome Back! 👋' : 'Create Account 🎉'}</h2>
              <p className="lm-sub">
                OTP sent to <strong>+91 {phone}</strong>
                <button className="lm-change"
                  onClick={() => { setStep('phone'); setOtp(['', '', '', '', '', '']); setError(''); }}>
                  Change
                </button>
              </p>

              <div className="lm-otp-row" onPaste={handleOtpPaste}>
                {otp.map((d, i) => (
                  <input
                    key={i} ref={el => otpRefs.current[i] = el}
                    type="tel" className={`lm-otp-box${d ? ' filled' : ''}`}
                    value={d} onChange={e => handleOtpChange(i, e.target.value)}
                    onKeyDown={e => handleOtpKeyDown(i, e)}
                    maxLength="1" disabled={loading}
                  />
                ))}
              </div>

              {error && <p className="lm-err lm-err-c">{error}</p>}

              <button className="lm-cta" onClick={handleVerifyOtp} disabled={loading || !otpComplete}>
                {loading
                  ? <span className="lm-spinner" />
                  : <><span>{userExists ? 'Login' : 'Create Account'}</span><span className="lm-arrow">→</span></>}
              </button>

              <div className="lm-resend">
                {countdown > 0
                  ? <p className="lm-countdown">Resend OTP in <strong>{countdown}s</strong></p>
                  : <button className="lm-resend-btn" onClick={handleResendOtp} disabled={loading}>Resend OTP</button>
                }
              </div>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default LoginModal;